import React from "react";
import loader from "../assets/icons/loader.svg";

const Spinner = ({ props, size }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <img
        className="animate-spin"
        width={size}
        height={size}
        src={loader}
        alt="Loading icon"
      />
      <h1 className="sm:text-left text-center md:text-xl">{props}</h1>
    </div>
  );
};

export default Spinner;
